import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import MainBarLink from './MainBarLink';

const useStyles = makeStyles(createStyles({
  root: {
    minHeight: 20,
    textTransform: 'capitalize',
    padding: '5px 15px 5px 0',
  },
}), { name: 'MainBarDropdownLink' });

type Props = React.ComponentProps<typeof MainBarLink>;

const MainBarDropdownLink = ({ className, ...props }: Props) => {
  const classes = useStyles();

  return (
    <MainBarLink
      className={clsx(classes.root, className)}
      {...props}
    />
  );
};

export default MainBarDropdownLink;
